import { getApi } from './api';
import { AxiosResponse } from "axios";

const URL = '/PowerBi';

export enum PowerBIReportsType {
    LocationOverview,
    CustomersDashboard,
}

export interface IPowerBIReportEmbedTokenResponse {
    embedToken: string,
    reportId: string,
    tenantId: string,
}

const getReportEmbedToken = async (type: PowerBIReportsType): Promise<IPowerBIReportEmbedTokenResponse> => {
    const api = await getApi();
    return api.post<any>(`${URL}/EmbedToken`, {reportType: type}).then((response: AxiosResponse<IPowerBIReportEmbedTokenResponse> ) => response.data);
};

const getDashboardEmbedToken = async (type: PowerBIReportsType): Promise<IPowerBIReportEmbedTokenResponse> => {
    const api = await getApi();
    return api.post<any>(`${URL}/DashboardEmbedToken`, {reportType: type}).then((response: AxiosResponse<IPowerBIReportEmbedTokenResponse> ) => response.data);
};


export const powerBiService = {
    getReportEmbedToken,
    getDashboardEmbedToken
};
